import React from "react";
import ReactDOM from "react-dom";
import ErrorBoundary from "./shared/components/error-boundary";
// import { trackEvent } from "../shared/tracking/tracking";
import Main from "./_attachment-section/main";

// const AttachmentSectionNoWrap = () => {
//   // trackEvent("AttachmentSection", { category: "BulkCardsAttachments", idCard: trelloIFrame.getContext().card as string })

//   const config = useConfigContext();

//   return (
//     <ConditionalRenderNew
//       condition1={!config}
//       condition2={!!config?.isUnderMaintenance}
//       renderIf1True={null}
//       renderIf2True={<UnderMaintenacePage />}
//       renderDefault={
//         <UserContextWrapper>
//           <AttachmentSectionMain />
//         </UserContextWrapper>
//       }
//     />
//   );
// };

// const AttachmentSection = () => (
//   <ErrorBoundary errorType="TopBoundryError">
//     <ConfigContextWrapper>
//       <AttachmentSectionNoWrap />
//     </ConfigContextWrapper>
//   </ErrorBoundary>
// );

const AttachmentSection = () => (
  <ErrorBoundary errorType="TopBoundryError">
    <Main />
  </ErrorBoundary>
);

export default AttachmentSection;
